/* eslint-disable no-case-declarations */
import * as userAction from "../actions/srp.action";
import { filterSlugGenerator } from "util/slugUtil";
const srp = (
  state = {
    selectedFilterObj: {},
    fliterGlobalSlugArray: [],
  },
  action,
) => {
  switch (action.type) {
    case userAction.UPDATE_FILTER_DATA:
      const newObj = action.filterData;
      const finalObj = { ...state.selectedFilterObj, ...newObj };
      let fliterGlobalSlugArray;
      if (finalObj && Object.keys(finalObj) && Object.keys(finalObj).length > 0) {
        fliterGlobalSlugArray = filterSlugGenerator(finalObj);
      } else {
        fliterGlobalSlugArray = [];
      }
      return Object.assign({}, state, {
        selectedFilterObj: action.filterData,
        fliterGlobalSlugArray,
      });

    default:
      return state;
  }
};
export default srp;
